import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Layout, Table, Icon } from "antd";

const { Content, Header } = Layout;

const StatusBadge = ({ status }) => {
  const styles = {
    success: { background: '#ecfdf5', color: '#10b981' },
    pending: { background: '#fffbeb', color: '#f59e0b' },
    failed: { background: '#fef2f2', color: '#ef4444' },
  };
  const style = styles[status] || styles.pending;

  return (
    <span style={{
      ...style,
      padding: '4px 12px',
      borderRadius: 20,
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'capitalize',
    }}>
      {status}
    </span>
  );
};

const columnsResults = [
  {
    title: "Task ID",
    dataIndex: "task_id",
    width: 380,
    render: text => (
      <Link to={"/result/" + text}>
        <code style={{ fontSize: 13 }}>{text}</code>
      </Link>
    )
  },
  {
    title: "Date",
    dataIndex: "time_scan",
    width: 220,
    render: text => (
      <span style={{ color: '#64748b', fontSize: 14 }}>
        <Icon type="clock-circle" style={{ marginRight: 8 }} />
        {text}
      </span>
    )
  },
  {
    title: "Status",
    dataIndex: "status",
    width: 120,
    render: status => <StatusBadge status={status} />
  }
];

export default class MyResultsPage extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      results: [],
      loading: true,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadResults();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadResults = () => {
    const { user } = this.props;
    if (!user) return;

    fetch("https://api.elfdigest.com:2083/usertasks/" + user.email, {
      method: 'get',
      credentials: 'include',
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })
      .then(res => res.json())
      .then(results => {
        if (this._isMounted && !results.hasOwnProperty("error")) {
          this.setState({ results, loading: false });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { results, loading } = this.state;
    let pagination = { pageSize: 20, size: "small" };

    return (
      <Layout style={{ marginLeft: 200 }}>
        <Header className="header">
          <h2 className="header-headline">My Reports</h2>
        </Header>
        <Content className="page-content">
          <div className="inner-page-content">
            {/* Stats Summary */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
              gap: 16,
              marginBottom: 24,
            }}>
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#6366f1' }}>
                  {results.length}
                </div>
                <div style={{ color: '#64748b', fontSize: 14 }}>Total Reports</div>
              </div>
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#10b981' }}>
                  {results.filter(r => r.status === 'success').length}
                </div>
                <div style={{ color: '#64748b', fontSize: 14 }}>Completed</div>
              </div>
              <div style={{
                background: '#fff',
                borderRadius: 12,
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                textAlign: 'center',
              }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: '#f59e0b' }}>
                  {results.filter(r => r.status === 'pending').length}
                </div>
                <div style={{ color: '#64748b', fontSize: 14 }}>Pending</div>
              </div>
            </div>

            <Table
              columns={columnsResults}
              dataSource={results}
              pagination={pagination}
              rowKey="task_id"
              loading={loading}
              locale={{
                emptyText: (
                  <div style={{ padding: '40px 0' }}>
                    <Icon type="inbox" style={{ fontSize: 48, color: '#cbd5e1', marginBottom: 16 }} />
                    <p style={{ color: '#64748b', margin: 0 }}>No reports yet. Submit a sample to get started.</p>
                  </div>
                )
              }}
            />
            <p style={{ color: '#94a3b8', textAlign: 'center', marginTop: 16, fontSize: 13 }}>
              <Icon type="sync" style={{ marginRight: 8 }} />
              Task status is updated every 5 minutes
            </p>
          </div>
        </Content>
      </Layout>
    );
  }
}
